import {ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideClientHydration, withEventReplay} from '@angular/platform-browser';
import {HttpClient, provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {authInterceptor} from './core/services/authentication/auth.interceptor';
import {loaderInterceptor} from './core/interceptors/loader.interceptor';
import {ssrUrlGuardInterceptor} from './core/interceptors/ssr-url-guard.interceptor';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {
  RECAPTCHA_LOADER_OPTIONS,
  RECAPTCHA_V3_SITE_KEY,
} from 'ng-recaptcha-2';
import {environment} from '../environments/environment';

// Cache-busting suffix — appends ?v=<timestamp> so the browser
// always fetches the latest /assets/i18n/<lang>.json after a deployment.
const CACHE_BUSTER = new Date().getTime();


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withFetch(),
      withInterceptors([
        ssrUrlGuardInterceptor, // block SSRF during SSR — must be first
        loaderInterceptor,
        authInterceptor,
      ]),
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    // Root TranslateService for the whole app
    provideTranslateService({
      // Load /assets/i18n/<lang>.json files with cache busting
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: `.json?v=${CACHE_BUSTER}`,
      }),

      // Initial and fallback languages
      lang: 'en',
      fallbackLang: 'en'
    }),
    // Recaptcha
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.RECAPTCHA_SITE_KEY },
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: () => ({
        onBeforeLoad() {
          const v3 = new URL('https://www.google.com/recaptcha/api.js');
          return { url: v3 };
        },
      }),
    },
  ]
};
